// extracted by mini-css-extract-plugin
export default {"button":"OpenInCanvasButton_button__dAnSX"};